import React from "react"
import { StatusBadgeProps } from "../types/badge"
import { Badge } from "react-bootstrap"

export const StatusBadge = (props: StatusBadgeProps) => {
    return (
        <Badge style={{
            backgroundColor: props.colorCode,
            padding: "4px 12px",
            color: "white",
        }}>
            {props.text}
        </Badge>
    )
}


// WEBPACK FOOTER //
// ./src/common/badge/StatusBadge.tsx